import type { FC, ComponentClass, ReactNode} from "react";
import { Fragment } from "react";

import type { Constructable } from "./types.ts";
import type { ViewModel} from "./ViewModel.ts";
import { ASSIGN } from "./ViewModel.ts";

type TConfiguration = {
  vmFactory: <T extends ViewModel>(VM: Constructable<T>) => T;
  Wrapper:
    | FC<{ children: ReactNode }>
    | ComponentClass<{ children: ReactNode }>;
};

export const configuration: TConfiguration = {
  vmFactory: (VM) => new VM(),
  Wrapper: Fragment,
};

export const configure = (config: Partial<TConfiguration>) => {
  ASSIGN(configuration, config);
};
